import { Focusable, useSpatialNavigation } from "@blacknut/spatialnav-sdk/dist";
import clsx from "clsx";
import { State } from "core";
import { useCallback } from "react";
import { useSelector } from "react-redux";
import { useAppNavigation } from "src/utils/Navigation/useAppNavigation";
import { ReactComponent as AvatarDefault } from "../../../assets/dist/ic_account_default.svg";
import { unreadNotificationsSelector } from "../../../components/AccountNavLink/AccountNavLink";
import AvatarImage from "../../../components/AvatarSelectionModal/AvatarImage";
import useAnonymousCheck from "../../../utils/useAnonymousCheck";
import styles from "./styles.module.scss";
import React from "react";
export const AccountHeaderRight = () => {
  const { profile } = useSelector((state: State) => state.profilesState);
  const unreadNotificationsLen = useSelector(unreadNotificationsSelector);

  const { navigate } = useAppNavigation();
  const { active: spatialNavigationActive } = useSpatialNavigation();
  const { checkForAnonymous } = useAnonymousCheck();
  const onClick = useCallback(() => {
    if (checkForAnonymous()) {
      navigate("/account/me");
    }
  }, [checkForAnonymous, navigate]);
  if (!profile) return null;
  return (
    <Focusable
      className={clsx(
        styles.icon,
        spatialNavigationActive && styles.spatialNavigationActive,
      )}
      data-testid="account"
      onClick={onClick}
      onPressEnter={onClick}
    >
      {profile.avatarId && <AvatarImage avatarId={profile.avatarId} />}

      {!profile.avatarId && <AvatarDefault className="svg" />}
      {unreadNotificationsLen > 0 && (
        <div className={styles.newBadge} data-testid="badge" />
      )}
    </Focusable>
  );
};
